import {isMarketingBoard} from '../utils';
import {matchPath} from 'react-router';
import React from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import {TRIPBOARD_DETAILS, TRIPBOARD_MARKETING} from '../../../routes';
import TripboardDetails from './details';
import {UserContext, UserProvider} from '../../user/user';

export function getUrl(route = '', boardId) {
    return route.replace(':boardId', boardId);
}

export function isRouteMatch(pathname, path) {
    const isMatch = matchPath(pathname, {path}) || {isExact: false};
    return isMatch.isExact;
}

/**
 * Redirect container for <TripboardDetails/>.
 * Handles updating the URL for analytics purposes.
 */
export function MarketingRedirect(props) {
    const {boardId, location, match} = props;
    const pathboardId = match && match.params && match.params.boardId;
    const resolvedBoardId = boardId ? boardId : pathboardId; // if we don't already have the boardId in props from the server-side render for some reason
    const isMarketing = isMarketingBoard(resolvedBoardId); /** @todo deprecate once graphql returns marketing flag */
    const isDefaultRoute = isRouteMatch(location.pathname, TRIPBOARD_DETAILS);
    const isMarketingRoute = isRouteMatch(location.pathname, TRIPBOARD_MARKETING);
    const usr = props.user || {};

    return (
        <React.Fragment>
            {isMarketing && isDefaultRoute &&
                <Redirect to={getUrl(TRIPBOARD_MARKETING, resolvedBoardId)} />
            }
            {!isMarketing && isMarketingRoute &&
                <Redirect to={getUrl(TRIPBOARD_DETAILS, resolvedBoardId)} />
            }
            <UserProvider {...usr}>
                <UserContext.Consumer>
                    {(user) => <TripboardDetails {...{...props, boardId: resolvedBoardId}} user={user} />}
                </UserContext.Consumer>
            </UserProvider>
        </React.Fragment>
    );
}

MarketingRedirect.defaultProps = {
    location: {}
};

export default withRouter(MarketingRedirect);



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/marketing-redirect.js